export default [
  {
    name: 'HSL',
    slug: 'hsl-40-76-n-111-88-w',
    date: 'Mar 19 2023',
    coords: '40.76 N, 111.88 W',
    location: 'Salt Lake City, UT',
    file: new URL('@/assets/restrooms/2023_03_19_HSL.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Minute Mart',
    slug: 'minute-mart-37-13-n-113-53-w',
    date: 'Apr 23 2023',
    coords: '37.13 N, 113.53 W',
    location: 'Washington, UT',
    file: new URL(
      '@/assets/restrooms/2023_04_23_Minute_Mart.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'ARCO am/pm',
    slug: 'arco-am-pm-34-88-n-117-02-w',
    date: 'Apr 23 2023',
    coords: '34.88 N, 117.02 W',
    location: 'Barstow, CA',
    file: new URL(
      '@/assets/restrooms/2023_04_23_ARCO_am_pm.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Ivanhoe Restaurant & Bar',
    slug: 'ivanhoe-restaurant-and-bar-34-11-n-118-26-w',
    date: 'Apr 25 2023',
    coords: '34.11 N, 118.26 W',
    location: 'Los Angeles, CA',
    file: new URL(
      '@/assets/restrooms/2023_04_25_Ivanhoe_Restaurant_and_Bar.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Green Valley Grocery',
    slug: 'green-valley-grocery-36-01-n-115-17-w',
    date: 'Apr 25 2023',
    coords: '36.01 N, 115.17 W',
    location: 'Las Vegas, NV',
    file: new URL(
      '@/assets/restrooms/2023_04_30_Green_Valley_Grocery.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Chipotle',
    slug: 'chipotle-37-11-n-113-55-w',
    date: 'Apr 30 2023',
    coords: '37.11 N, 113.55 W',
    location: 'St. George, UT',
    file: new URL('@/assets/restrooms/2023_04_30_Chipotle.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Dairy Queen',
    slug: 'dairy-queen-43-83-n-111-78-w',
    date: 'May 04 2023',
    coords: '43.83 N, 111.78 W',
    location: 'Rexburg, ID',
    file: new URL(
      '@/assets/restrooms/2023_05_04_Dairy_Queen.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Yellowstone Lodge',
    slug: 'yellowstone-lodge-44-46-n-110-83-w',
    date: 'May 05 2023',
    coords: '44.46 N, 110.83 W',
    location: 'Yellowstone National Park, WY',
    file: new URL(
      '@/assets/restrooms/2023_05_05_Yellowstone_Lodge.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Maverick',
    slug: 'maverick-42-88-n-112-42-w',
    date: 'May 07 2023',
    coords: '42.88 N, 112.42 W',
    location: 'Pocatello, ID',
    file: new URL('@/assets/restrooms/2023_05_07_Maverick.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: "Cubby's",
    slug: 'cubbys-40-38-n-111-82-w',
    date: 'Jun 01 2023',
    coords: '40.38 N, 111.82 W',
    location: 'American Fork, UT',
    file: new URL('@/assets/restrooms/2023_06_01_Cubbys.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: "Tom Sawyer's Island, Disneyland",
    slug: 'tom-sawyers-island-disneyland-33-81-n-117-92-w',
    date: 'Jun 24 2023',
    coords: '33.81 N, 117.92 W',
    location: 'Anaheim, CA',
    file: new URL(
      '@/assets/restrooms/2023_06_24_Tom_Sawyers_island_Disneyland.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: "Gio's Family Dining",
    slug: 'gios-family-dining-40-09-n-108-79-w',
    date: 'Jul 20 2023',
    coords: '40.09 N, 108.79 W',
    location: 'Rangeley, CO',
    file: new URL(
      '@/assets/restrooms/2023_07_20_Gios_Family_Dining.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Lazy Bear Restaurant',
    slug: 'lazy-bear-restaurant-39-57-n-107-53-w',
    date: 'Jul 20 2023',
    coords: '39.57 N, 107.53 W',
    location: 'New Caslte, CO',
    file: new URL(
      '@/assets/restrooms/2023_07_20_Lazy_Bear_Restaurant.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'EDEKA Sanft',
    slug: 'edeka-sanft-49-82-n-6-75-e',
    date: 'Oct 12, 2023',
    coords: '49.82 N, 6.75 E',
    location: 'Schweich, DE',
    file: new URL(
      '@/assets/restrooms/2023_10_12_EDEKA_Sanft.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Water Witch',
    slug: 'water-witch-40-75-n-111-90-w',
    date: 'Nov 17, 2023',
    coords: '40.75 N, 111.90 W',
    location: 'Salt Lake City, UT',
    file: new URL(
      '@/assets/restrooms/2023_11_17_Water_Witch.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Kneaders',
    slug: 'kneaders-40-30-n-111-66-w',
    date: 'Dec 21 2023',
    coords: '40.30 N, 111.66 W',
    location: 'Provo, UT',
    file: new URL(
      '@/assets/restrooms/2023_12_21_Kneaders_Riverwoods.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Wildwood',
    slug: 'wildwood-40-77-n-111-87-w',
    date: 'Dec 23 2023',
    coords: '40.77 N, 111.87 W',
    location: 'Salt Lake City, UT',
    file: new URL('@/assets/restrooms/2023_12_23_Wildwood.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: 'The Boathouse',
    slug: 'the-boathouse-34-40-n-119-74-w',
    date: 'Mar 18 2024',
    coords: '34.40 N, 119.74 W',
    location: 'Santa Barbara, CA',
    file: new URL(
      '@/assets/restrooms/2024_03_18_The_Boathouse_Hendrys_Beach.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'New York Chicken & Gyro',
    slug: 'new-york-chicken-and-gyro-34-21-n-118-61-w',
    date: 'Mar 21 2024',
    coords: '34.21 N, 118.61 W',
    location: 'Los Angeles, CA',
    file: new URL(
      '@/assets/restrooms/2024_03_21_New_York_Chicken_and_Gyro.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Cucina',
    slug: 'cucina-40-77-n-111-86-w',
    date: 'Apr 21 2024',
    coords: '40.77 N, 111.86 W',
    location: 'Salt Lake City, UT',
    file: new URL('@/assets/restrooms/2024_04_21_Cucina.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Nohm',
    slug: 'nohm-40-75-n-111-90-w',
    date: 'May 19 2024',
    coords: '40.75 N, 111.90 W',
    location: 'Salt Lake City, UT',
    file: new URL('@/assets/restrooms/2024_05_19_Nohm.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: 'UMOCA',
    slug: 'umoca-40-77-n-111-89-w',
    date: 'Jun 20 2024',
    coords: '40.77 N, 111.89 W',
    location: 'Salt Lake City, UT',
    file: new URL('@/assets/restrooms/2024_06_20_UMOCA.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: "Grandpa's Bookshelf",
    slug: 'grandpas-bookshelf-41-73-n-111-84-w',
    date: 'Jun 29 2024',
    coords: '41.73 N, 111.84 W',
    location: 'Logan, UT',
    file: new URL(
      '@/assets/restrooms/2024_06_29_Grandpas_Bookshelf.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Island Market',
    slug: 'island-market-41-73-n-111-82-w',
    date: 'Jun 29 2024',
    coords: '41.73 N, 111.82 W',
    location: 'Logan, UT',
    file: new URL(
      '@/assets/restrooms/2024_06_29_Island_Market.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: "Jack's Woodfired Pizza",
    slug: 'jacks-woodfired-pizza-41-74-n-111-83-w',
    date: 'Jun 29 2024',
    coords: '41.74 N, 111.83 W',
    location: 'Logan, UT',
    file: new URL(
      '@/assets/restrooms/2024_06_29_Jacks_Woodfired_Pizza.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'High Country Pizza & Deli',
    slug: 'high-country-pizza-and-deli-40-30-n-109-98-w',
    date: 'Jul 20 2024',
    coords: '40.30 N, 109.98 W',
    location: 'Roosevelt, UT',
    file: new URL(
      '@/assets/restrooms/2024_07_20_High_Country_Pizza_and_Deli.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Hilltop Tavern',
    slug: 'hilltop-tavern-40-66-n-73-98-w',
    date: 'Aug 08 2024',
    coords: '40.66 N, 73.98 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2024_08_08_Hilltop_Tavern.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: "Zaytoon's",
    slug: 'zaytoons-40-68-n-73-97-w',
    date: 'Aug 09 2024',
    coords: '40.68 N, 73.97 W',
    location: 'Brooklyn, NY',
    file: new URL('@/assets/restrooms/2024_08_09_Zaytoons.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: "Caputo's",
    slug: 'caputos-40-74-n-111-85-w',
    date: 'Aug 18 2024',
    coords: '40.74 N, 111.85 W',
    location: 'Salt Lake City, UT',
    file: new URL(
      '@/assets/restrooms/2024_08_18_Caputos_15th_Street.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Publik Coffee Roasters',
    slug: 'publik-coffee-roasters-40-77-n-111-87-w',
    date: 'Aug 23 2024',
    coords: '40.77 N, 111.87 W',
    location: 'Salt Lake City, UT',
    file: new URL(
      '@/assets/restrooms/2024_08_23_Publik_Coffee_Roasters_The_Avenues.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Peace on Earth Coffee',
    slug: 'peace-on-earth-coffee-40-23-n-111-66-w',
    date: 'Sep 05 2024',
    coords: '40.23 N, 111.66 W',
    location: 'Provo, UT',
    file: new URL(
      '@/assets/restrooms/2024_09_05_Peace_on_Earth_Coffee.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Bombay House',
    slug: 'bombay-house-40-24-n-111-66-w',
    date: 'Sep 07 2024',
    coords: '40.24 N, 111.66 W',
    location: 'Provo, UT',
    file: new URL(
      '@/assets/restrooms/2024_09_07_Bombay_House_Provo.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: "Guru's",
    slug: 'gurus-40-23-n-111-66-w',
    date: 'Sep 07 2024',
    coords: '40.23 N, 111.66 W',
    location: 'Provo, UT',
    file: new URL('@/assets/restrooms/2024_09_07_Gurus.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Krupa Grocery',
    slug: 'krupa-grocery-40-66-n-73-98-w',
    date: 'Sep 11 2024',
    coords: '40.66 N, 73.98 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2024_09_11_Krupa_Grocery.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Buttermilk Bar',
    slug: 'buttermilk-bar-40-66-n-73-98-w',
    date: 'Sep 14 2024',
    coords: '40.66 N, 73.98 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2024_09_14_Buttermilk_bar.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Fonda Comida Mexicana',
    slug: 'fonda-comida-mexicana-40-66-n-73-98-w',
    date: 'Sep 20 2024',
    coords: '40.66 N, 73.98 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2024_09_20_Fonda_Comida_Mexicana.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Double Windsor',
    slug: 'double-windsor-40-66-n-73-98-w',
    date: 'Sep 26 2024',
    coords: '40.66 N, 73.98 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2024_09_26_Double_Windsor.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Red Hook Lobster Pound',
    slug: 'red-hook-lobster-pound-40-68-n-74-01-w',
    date: 'Oct 05 2024',
    coords: '40.68 N, 74.01 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2024_10_05_Red_Hook_Lobster_Pound.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Iris Cafe',
    slug: 'iris-cafe-40-69-n-74-00-w',
    date: 'Oct 13 2024',
    coords: '40.69 N, 74.00 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2024_10_13_Iris_Cafe.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Commonwealth Bar (Some restroom)',
    slug: 'commonwealth-bar-some-restroom-40-67-n-73-99-w',
    date: 'Oct 16 2024',
    coords: '40.67 N, 73.99 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2024_10_16_Commonwealth_Bar_some.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Commonwealth Bar (Others restroom)',
    slug: 'commonwealth-bar-others-restroom-40-67-n-73-99-w',
    date: 'Oct 16 2024',
    coords: '40.67 N, 73.99 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2024_10_16_Commonwealth_Bar_others.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Super Burrito',
    slug: 'super-burrito-40-59-n-73-80-w',
    date: 'Oct 26 2024',
    coords: '40.59 N, 73.80 W',
    location: 'Queens, NY',
    file: new URL(
      '@/assets/restrooms/2024_10_26_Super_Burrito.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Miti Miti',
    slug: 'miti-miti-40-68-n-73-98-w',
    date: 'Nov 22 2024',
    coords: '40.68 N, 73.98 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2024_11_22_Miti_Miti.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'The Mart Collective',
    slug: 'the-mart-collective-34-00-n-118-46-w',
    date: 'Dec 02 2024',
    coords: '34.00 N, 118.46 W',
    location: 'Los Angeles, CA',
    file: new URL(
      '@/assets/restrooms/2024_12_02_The-Mart_Collective.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: "Luana's Tavern",
    slug: 'luanas-tavern-40-68-n-74-00-w',
    date: 'Dec 07 2024',
    coords: '40.68 N, 74.00 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2024_12_07_Launas_Tavern.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Close Up',
    slug: 'close-up-40-72-n-73-98-w',
    date: 'Dec 20 2024',
    coords: '40.72 N, 73.98 W',
    location: 'Manhattan, NY',
    file: new URL('@/assets/restrooms/2024_12_20_Close_Up.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: "Milady's",
    slug: 'miladys-40-73-n-74-00-w',
    date: 'Dec 20 2024',
    coords: '40.73 N, 74.00 W',
    location: 'Manhattan, NY',
    file: new URL('@/assets/restrooms/2024_12_20_Miladys.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Skylark',
    slug: 'skylark-40-67-n-73-99-w',
    date: 'Jan 31 2025',
    coords: '40.67 N, 73.99 W',
    location: 'Brooklyn, NY',
    file: new URL('@/assets/restrooms/2025_01_31_Skylark.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Best Pizza',
    slug: 'best-pizza-40-71-n-73-95-w',
    date: 'Mar 16 2025',
    coords: '40.71 N, 73.95 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2025_03_16_Best_Pizza.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Big Reuse',
    slug: 'big-reuse-40-67-n-73-99-w',
    date: 'Mar 29 2025',
    coords: '40.67 N, 73.99 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2025_03_29_big_reuse.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: "Ray's Pizza",
    slug: 'rays-pizza-40-78-n-73-97-w',
    date: 'Apr 12 2025',
    coords: '40.78 N, 73.97 W',
    location: 'Manhattan, NY',
    file: new URL(
      '@/assets/restrooms/2025_04_12_Rays_Pizza.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Pho Bang',
    slug: 'pho-bang-40-72-n-74-00-w',
    date: 'Apr 22 2025',
    coords: '40.72 N, 74.00 W',
    location: 'Manhattan, NY',
    file: new URL('@/assets/restrooms/2025_04_22_Pho Bang.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: "Clark's",
    slug: 'clarks-40-70-n-73-99-w',
    date: 'Apr 24 2025',
    coords: '40.70 N, 73.99 W',
    location: 'Brooklyn, NY',
    file: new URL('@/assets/restrooms/2025_04_24_Clarks.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Noble Pies',
    slug: 'noble-pies-41-08-n-73-86-w',
    date: 'Apr 26 2025',
    coords: '41.08 N, 73.86 W',
    location: 'Tarrytown, NY',
    file: new URL(
      '@/assets/restrooms/2025_04_26_Noble_Pies.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Red Pepper Diner',
    slug: 'red-pepper-diner-41-51-n-73-95-w',
    date: 'Apr 26 2025',
    coords: '41.51 N, 73.95 W',
    location: 'Beacon, NY',
    file: new URL(
      '@/assets/restrooms/2025_04_26_Red_Pepper_Diner.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Vanderbilt Mansion National Historic Site',
    slug: 'vanderbilt-mansion-national-historic-site-41-80-n-73-94-w',
    date: 'Apr 27 2025',
    coords: '41.80 N, 73.94 W',
    location: 'Hyde Park, NY',
    file: new URL(
      '@/assets/restrooms/2025_4_27_Vanderbilt_Mansion.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Matchbox Cafe',
    slug: 'matchbox-cafe-41-92-n-73-91-w',
    date: 'Apr 27 2025',
    coords: '41.92 N, 73.91 W',
    location: 'Rhinebeck, NY',
    file: new URL(
      '@/assets/restrooms/2025_04_27_Matchbox_Cafe.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Good Thanks',
    slug: 'good-thanks-40-72-n-73-99-w',
    date: 'Apr 29 2025',
    coords: '40.72 N, 73.99 W',
    location: 'Manhattan, NY',
    file: new URL(
      '@/assets/restrooms/2025_04_29_Good_Thanks.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: "Fraunce's Tavern Museum",
    slug: 'fraunces-tavern-museum-40-70-n-74-01-w',
    date: 'Apr 29 2025',
    coords: '40.70 N, 74.01 W',
    location: 'Manhattan, NY',
    file: new URL(
      '@/assets/restrooms/2025_04_29_Fraunces_Tavern.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Hex House',
    slug: 'hex-house-40-70-n-74-01-w',
    date: 'May 27 2025',
    coords: '40.71 N, 73.94 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2025_05_27_Hex_House.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Greenwood Park',
    slug: 'greenwood-park-40-66-n-73-99-w',
    date: 'May 27 2025',
    coords: '40.66 N, 73.99 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2025_05_27_Greenwood_Park.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: '81 Prospect St, Floor 4',
    slug: '81-prospect-st-40-70-n-73-99-w',
    date: 'May 31 2025',
    coords: '40.70 N, 73.99 W',
    location: 'Brooklyn, NY',
    file: new URL(
      '@/assets/restrooms/2025_05_31_81_Prospect_St.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Treasures Antique Mall South',
    slug: 'treasures-antique-mall-south-40-18-n-111-65-w',
    date: 'Jun 07 2025',
    coords: '40.18 N, 111.65 W',
    location: 'Springville, UT',
    file: new URL(
      '@/assets/restrooms/2025_06_07_Treasures_Antique_Mall_South.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
  {
    name: "Edie Jo's",
    slug: 'edie-jos-40-66-n-73-96-w',
    date: 'Jul 04 2025',
    coords: '40.66 N, 73.96 W',
    location: 'Brooklyn, NY',
    file: new URL('@/assets/restrooms/2025_07_04_Edie_Jos.glb', import.meta.url)
      .href,
    attribution: 'Jake Welch',
  },
  {
    name: 'Pace Gallery',
    slug: 'pace-gallery-40-75-n-74-01-w',
    date: 'Jul 17 2025',
    coords: '40.75 N, 74.01 W',
    location: 'Manhattan, NY',
    file: new URL(
      '@/assets/restrooms/2025_07_17_Pace_Gallery.glb',
      import.meta.url
    ).href,
    attribution: 'Jake Welch',
  },
];
